import { AxiosRequestConfig } from "axios";
import axiosService from "./axiosInstance";


function getData<ResponseData>(url: string, config?: AxiosRequestConfig) {
  return axiosService.getAxiosInstance().get<ResponseData>(url, config);
}

function getPostData<RequestData, ResponseData>(url: string, data?: RequestData, config?: AxiosRequestConfig) {
	return axiosService.getAxiosInstance().post<ResponseData>(url, data, config);
}

function postData<RequestData, ResponseData>(
  url: string,
  data?: RequestData,
  config?: AxiosRequestConfig
) {
  return axiosService.getAxiosInstance().post<ResponseData>(url, data, config);
}

function deleteDataList<RequestData, ResponseData>(url: string, data?: RequestData) {
	return axiosService.getAxiosInstance().delete<ResponseData>(url, { data });
}

function deleteData<ResponseData>(url: string, config?: AxiosRequestConfig) {
  return axiosService.getAxiosInstance().delete<ResponseData>(url, config);
}

function patchData<RequestData, ResponseData>(url: string, data?: RequestData) {
  return axiosService.getAxiosInstance().patch<ResponseData>(url, data);
}
function putData<RequestData, ResponseData>(url: string, data?: RequestData) {
  return axiosService.getAxiosInstance().put<ResponseData>(url, data);
}

export { getData, getPostData, postData, deleteData, deleteDataList, patchData, putData };
